import { createSlice } from "@reduxjs/toolkit";
import { getFolderURLFromSpinURL } from "../../util/general";
import { setSpinURL } from "../spinURL/spinURL";

export const initialState = {
  folderURL: "",
};

export const folderURLSlice = createSlice({
  name: "folderURL",
  initialState,
  reducers: {
    setFolderURL(state, action) {
      state.folderURL = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setSpinURL, (state, action) => {
      const spinURL = action.payload;
      if (!spinURL) {
        console.warn("setSpinURL has been dispatched without payload");
        return;
      }
      state.folderURL = getFolderURLFromSpinURL(spinURL);
    });
  },
});

export const { setFolderURL } = folderURLSlice.actions;

export default folderURLSlice.reducer;

//========== SELECTORS ============
export const getFolderURL = (state) => state.folderURL;
export const getHostname = (state) => {
  const urlObj = new URL(state.folderURL);
  return urlObj.hostname;
};
